import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import * as loginApi from 'src/apis/login';
import { useDispatch } from 'react-redux';
import { Creators } from 'src/store/ducks/login';
import './style.scss'
import { generateChallenge, generateVerifier } from 'src/utils/pkce';
import refreshTokenSemaphore from 'src/utils/Semaphore';

/**
 * Renders Login Page
 * @returns {JSX.Component} The Login Page
 * @example
 * <LoginPage />
 */
function LoginPage() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParameters = new URLSearchParams(location.search);
    const accessToken = queryParameters.get('access');

    useEffect(() => {
        refreshTokenSemaphore.unlockTokenValidation();
    }, [])

    const authenticate = useCallback(async () => {
        // PKCE
        const verifier = generateVerifier();
        localStorage.setItem('code-verifier', verifier);
        const challenge = await generateChallenge(verifier);

        await loginApi
            .getToken(accessToken, challenge)
            .catch(err => {
                console.error("Error on trying to get authentication token", err);
                window.location.href = '/unauthentication';
            })

        dispatch(Creators.setLogin(true));
        
        loginApi.getLoggedUser().then(response => {
            if(response.data.result) dispatch(Creators.setSessionUser(response.data.result));
            history.push('/');
        }).catch(err => {
            console.error("Error on trying to authenticate", err);
            localStorage.removeItem('code-verifier');
            window.location.href = '/unauthentication';
        })
    }, [accessToken, dispatch, history])

    useEffect(() => {
        async function fetchData() {
            await authenticate();
        }
        fetchData();
    }, [authenticate]);

    return (
        <div className="login-page">
            <LoadingOutlined onLoad={authenticate} style={{fontSize: 30}} spin />
        </div>
    );
}

export default LoginPage;
